import type { BacktestListFilters } from "../bots/backtest-queries.js";
import type { BacktestStatus } from "../bots/backtest-models.js";

export const backtestStatuses: readonly BacktestStatus[] = [
  "queued",
  "running",
  "completed",
  "failed",
  "cancelled",
];

function isBacktestStatus(value: string): value is BacktestStatus {
  return backtestStatuses.some((status) => status === value);
}

export function backtestPageSize(value: string): number {
  const parsed = Number(value);
  return [25, 50, 100].includes(parsed) ? parsed : 25;
}

export function backtestFilters(search: URLSearchParams): BacktestListFilters {
  const botId = search.get("bot")?.trim() ?? "";
  const from = search.get("from") ?? "";
  const status = search.get("status") ?? "";
  const symbol = search.get("symbol")?.trim() ?? "";
  const to = search.get("to") ?? "";
  return {
    ...(botId === "" ? {} : { botId }),
    ...(from === "" ? {} : { from }),
    ...(isBacktestStatus(status) ? { status } : {}),
    ...(symbol === "" ? {} : { symbol: symbol.toUpperCase() }),
    ...(to === "" ? {} : { to }),
  };
}
